// Apollo GraphQL mocks removed — AuthProvider now uses REST/React Query.
// Exports retained for backward compat; passed to render({ mocks: [...] }) which is a no-op.

const CURRENT_USER = {
  email: 'test@test.com',
  id: '1',
  otpVerified: false,
  authenticatorAppEnabled: false,
  profile: {
    bankAccountName: 'Main',
    bankAccountNumber: '12-3140-0577999-01',
    firstName: 'Glen',
    identifier: '123-456-789',
    onboarded: true,
    preferredName: 'Glennie',
    reference: '094C265C',
    addressLine1: 'Level 2',
    addressLine2: '1 Ghuznee Street',
    suburb: 'Te Aro',
    city: 'Wellington',
    postcode: '6011',
    lastName: 'Mr',
    partialIdentityVerified: true,
    dateOfBirth: '1978-01-10',
    referralCode: 'GLEN2971',
    driversLicenceNumber: 'DP012345',
    driversLicenceVersion: '391',
    passportNumber: null,
    passportExpiry: null,
    verificationMethod: 'drivers_licence',
    ethnicity: 'NZ European'
  },
  reference: 'TEST123',
  securitiesOwned: [
    {
      product: {
        name: 'Gold',
        id: '1',
        description: '1KG bar of 99.99% pure gold',
        tradable: true,
        unitType: 'mg',
        __typename: 'Product'
      },
      securities: [],
      quantityOwned: 0,
      hasHistory: true,
      __typename: 'SecuritiesOwned'
    },
    {
      product: {
        name: 'Silver',
        id: '2',
        description: '1KG bar of 99.99% pure silver',
        tradable: true,
        unitType: 'mg',
        __typename: 'Product'
      },
      securities: [],
      quantityOwned: 0,
      hasHistory: true,
      __typename: 'SecuritiesOwned'
    }
  ],
  wallet: {
    balance: '4973.73',
    userId: '1',
    walletBalance: '4973.73',
    expirableWalletCreditBalance: '0.0',
    rewardCredit: '0.0',
    voucherCredit: '0.0'
  },
  vaults: [],
  activatedVault: null,
  firstTimeTopUpWithPoli: false,
  firstTimeTopUpWithBlinkpay: false,
  autoInvests: {
    amount: '100.0',
    duration: 'weekly',
    nextAutoinvestDate: '2024-02-10',
    id: 1,
    product: {
      name: 'Gold',
      unitType: 'mg'
    },
    investBy: 'dollar'
  }
}

export const initialUserMock = {
  result: { data: { currentUser: CURRENT_USER } }
}

export const currentUserMock = {
  result: { data: { currentUser: CURRENT_USER } }
}

export const otpVerifiedUserMock = {
  result: {
    data: { currentUser: { ...CURRENT_USER, otpVerified: true } }
  }
}

export const authAppEnabledUserMock = {
  result: {
    data: { currentUser: { ...CURRENT_USER, authenticatorAppEnabled: true } }
  }
}

export const authAppAndOtpVerifiedUserMock = {
  result: {
    data: {
      currentUser: {
        ...CURRENT_USER,
        authenticatorAppEnabled: true,
        otpVerified: true
      }
    }
  }
}

export const nonOnboardedUserMock = {
  result: {
    data: {
      currentUser: {
        ...CURRENT_USER,
        profile: {
          ...CURRENT_USER.profile,
          onboarded: false // User has NOT completed onboarding
        }
      }
    }
  },
  newData: () => nonOnboardedUserMock.result
}

export const generateOtpMock = {
  result: { data: { generateOtp: true } }
}

export const productsMock = {
  result: {
    data: {
      products: [
        {
          id: '1',
          name: 'Gold',
          description: '1KG bar of 99.99% pure gold',
          sku: 'GOLD001',
          tradable: true,
          unitType: 'mg'
        },
        {
          id: '2',
          name: 'Silver',
          description: '1KG bar of 99.9% pure silver',
          sku: 'SILV001',
          tradable: true,
          unitType: 'mg'
        }
      ]
    }
  }
}
